const ID_TOKEN_KEY = "id_token";
const ID_REFRESHTOKEN_KEY = "id_refresh_token";
const ID_SAVE_LOGININFO_KEY = "id_loginInfo";
const ID_USER_ID_KEY = "id_user";

export const getAccessToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveAccessToken = (token) => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyAccessToken = () => {
  console.log("destroyAccessToken");
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const getRefreshToken = () => {
  return window.localStorage.getItem(ID_REFRESHTOKEN_KEY);
};

export const saveRefreshToken = (token) => {
  window.localStorage.setItem(ID_REFRESHTOKEN_KEY, token);
};

export const destroyRefreshToken = () => {
  console.log("destroyRefreshToken");
  window.localStorage.removeItem(ID_REFRESHTOKEN_KEY);
};

export const getLoginInfo = () => {
  return window.localStorage.getItem(ID_SAVE_LOGININFO_KEY);
};

export const saveLoginInfo = (loginInfo) => {
  window.localStorage.setItem(ID_SAVE_LOGININFO_KEY, loginInfo);
};

export const removeLoginInfo = () => {
  window.localStorage.removeItem(ID_SAVE_LOGININFO_KEY);
};

export const getUserId = () => {
  return window.localStorage.getItem(ID_USER_ID_KEY);
};

export const saveUserId = (userId) => {
  window.localStorage.setItem(ID_USER_ID_KEY, userId);
};

export const removeUserId = () => {
  window.localStorage.removeItem(ID_USER_ID_KEY);
};

export default {
  getAccessToken,
  saveAccessToken,
  destroyAccessToken,
  getRefreshToken,
  saveRefreshToken,
  destroyRefreshToken,
  getLoginInfo,
  saveLoginInfo,
  removeLoginInfo,
  getUserId,
  saveUserId,
  removeUserId,
};
